import { useTranslation } from 'react-i18next';
import useAllPackageUrl from './hooks/useAllPackageUrl';

export const WinePackageLink = ({ textColor }: { textColor: string }) => {
  const { t } = useTranslation();
  // @ts-ignore
  const isAdmin = window.isAdminPage;
  // @ts-ignore
  const languageCode = window.currentLanguageCode;

  const { createAllPackageUrl } = useAllPackageUrl();
  const url = createAllPackageUrl(languageCode);
  return (
    <a href={url} className='font-body ml-3 mr-2' style={{ color: textColor }} onClick={(e) => isAdmin && e.preventDefault()}>
      {t('winePackageWidget.allPackages')}
    </a>
  );
};
